/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Defines the access state for users and external applications.
 */
export enum EnumAccessState {
    /**
     * The entity is unlocked and access is permitted.
     */
    Unlocked = 0,
    /**
     * The entity is locked and access is denied.
     */
    Locked = 1,
}
